import React, { useEffect, useMemo, useState } from "react";
import {
    Box,
    Button,
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    TextField,
    Typography,
    Paper,
    InputAdornment,
    Switch,
} from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import LockIcon from "@mui/icons-material/Lock";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";

import { API_URL } from "../../env";

import { useDispatch, useSelector } from "react-redux";

import {
    fetchBarcodePrintSetting,
    saveBarcodePrintSetting,
} from "../../Redux/BarcodeRateSetting/BarcodePrintSettingSlice";

import { showToast } from "../../Helpers/showToast";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { CustomStringify } from "../../Helpers/CustomStringify";
import { editUserDetail } from "../../Redux/UserDetail/UserDetailSlice";

function BarcodeSettings() {

    // REDUX


    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { cmpdetail } = useSelector(
        (state) => state.CompanyDetail
    );

    const UserDetail = useSelector(
        (state) => state.UserDetail
    );

    const barcodeSettings = useSelector(
        (state) =>
            state.BarcodePrintSetting?.BarPrintSetting
    );


    // PASSWORD


    const [STATIC_PASSWORD, setSTATIC_PASSWORD] = useState("a");

    const [passwordModalOpen, setPasswordModalOpen] =
        useState(true);

    const [password, setPassword] = useState("");

    const [showPassword, setShowPassword] =
        useState(false);

    const [passwordError, setPasswordError] =
        useState("");

    const [verified, setVerified] =
        useState(false);


    // BARCODE SETTINGS


    const [settings, setSettings] = useState({
        App_Barcode_3825_Type: false,
        App_Barcode_5025_Type: false,
        App_Barcode_5035_Type: false,
        App_Barcode_5038_Type: false,
        App_Barcode_6040_Type: false,
        App_Barcode_7038_Type: false,

        barcode_Hide_WS_MRP_Rate: false,

        Inner_Prop: [
            {
                BarcodeType: "38x25",
                BarcodeFormat: "Format 1 - Barcode Line",
                Barcode_With_Currency: false,
                Barcode_Content1: "",
                Barcode_Content2: "",
                Barcode_Content3: "",
                Barcode_Content4: "",
                Barcode_Content5: "",
                Barcode_Content6: "",
                Barcode_ContentFont1: "",
                Barcode_ContentFont2: "",
                Barcode_ContentFont3: "",
                Barcode_ContentFont4: "",
                Barcode_ContentFont5: "",
                Barcode_ContentFont6: "",
                Barcode_SetQtyCaption: "",
            },
            {
                BarcodeType: "50x25",
                BarcodeFormat: "Format 1 - Barcode Line",
                Barcode_With_Currency: false,
                Barcode_Content1: "",
                Barcode_Content2: "",
                Barcode_Content3: "",
                Barcode_Content4: "",
                Barcode_Content5: "",
                Barcode_Content6: "",
                Barcode_ContentFont1: "",
                Barcode_ContentFont2: "",
                Barcode_ContentFont3: "",
                Barcode_ContentFont4: "",
                Barcode_ContentFont5: "",
                Barcode_ContentFont6: "",
                Barcode_SetQtyCaption: "",
            },
            {
                BarcodeType: "50x35",
                BarcodeFormat: "Format 1 - Barcode Line",
                Barcode_With_Currency: false,
                Barcode_Content1: "",
                Barcode_Content2: "",
                Barcode_Content3: "",
                Barcode_Content4: "",
                Barcode_Content5: "",
                Barcode_Content6: "",
                Barcode_ContentFont1: "",
                Barcode_ContentFont2: "",
                Barcode_ContentFont3: "",
                Barcode_ContentFont4: "",
                Barcode_ContentFont5: "",
                Barcode_ContentFont6: "",
                Barcode_SetQtyCaption: "",
            },
            {
                BarcodeType: "38x50",
                BarcodeFormat: "Format 1 - Barcode Line",
                Barcode_With_Currency: false,
                Barcode_Content1: "",
                Barcode_Content2: "",
                Barcode_Content3: "",
                Barcode_Content4: "",
                Barcode_Content5: "",
                Barcode_Content6: "",
                Barcode_ContentFont1: "",
                Barcode_ContentFont2: "",
                Barcode_ContentFont3: "",
                Barcode_ContentFont4: "",
                Barcode_ContentFont5: "",
                Barcode_ContentFont6: "",
                Barcode_SetQtyCaption: "",
            },
            {
                BarcodeType: "60x40",
                BarcodeFormat: "Format 1 - Barcode Line",
                Barcode_With_Currency: false,
                Barcode_Content1: "",
                Barcode_Content2: "",
                Barcode_Content3: "",
                Barcode_Content4: "",
                Barcode_Content5: "",
                Barcode_Content6: "",
                Barcode_ContentFont1: "",
                Barcode_ContentFont2: "",
                Barcode_ContentFont3: "",
                Barcode_Content4: "",
                Barcode_ContentFont5: "",
                Barcode_ContentFont6: "",
                Barcode_SetQtyCaption: "",
            },
            {
                BarcodeType: "70x38",
                BarcodeFormat: "Format 1 - Barcode Line",
                Barcode_With_Currency: false,
                Barcode_Content1: "",
                Barcode_Content2: "",
                Barcode_Content3: "",
                Barcode_Content4: "",
                Barcode_Content5: "",
                Barcode_Content6: "",
                Barcode_ContentFont1: "",
                Barcode_ContentFont2: "",
                Barcode_ContentFont3: "",
                Barcode_ContentFont4: "",
                Barcode_ContentFont5: "",
                Barcode_ContentFont6: "",
                Barcode_SetQtyCaption: "",
            },
        ],
    });


    // BARCODE MODALS


    const [selectedBarcodeType, setSelectedBarcodeType] =
        useState(null);

    const [barcodeModalOpen, setBarcodeModalOpen] =
        useState(false);

    const [barcodePreviewOpen, setBarcodePreviewOpen] =
        useState(false);


    // SUPPLIER FORMAT MODAL


    const [supplierFormatModalOpen, setSupplierFormatModalOpen] =
        useState(false);

    const [selectedSupplierFormat, setSelectedSupplierFormat] =
        useState("");

    const [isSaving, setIsSaving] =
        useState(false);


    // BARCODE TYPE CONFIGURATION


    const barcodeTypes = [
        {
            label: "38X25",
            key: "App_Barcode_3825_Type",
            innerType: "38x25",
            Img: "https://eterp.in/static/media/38x25.63a937792710fd3fc847.png",
        },
        {
            label: "50X25",
            key: "App_Barcode_5025_Type",
            innerType: "50x25",
            Img: "https://eterp.in/static/media/50x25.3fcb17c14406c714cb9b.png",
        },
        {
            label: "50X35",
            key: "App_Barcode_5035_Type",
            innerType: "50x35",
            Img: "https://eterp.in/static/media/50x35.f3f2e81c750e0cd82872.png",
        },
        {
            label: "50X38",
            key: "App_Barcode_5038_Type",
            innerType: "38x50",
            Img: "https://eterp.in/static/media/38x50-Barcode.0c48c26cc58b81dde0d3.png",
        },
        {
            label: "60X40",
            key: "App_Barcode_6040_Type",
            innerType: "60x40",
            Img: "https://eterp.in/static/media/60x40.6794bab8b0869d12a367.png",
        },
        {
            label: "70X38",
            key: "App_Barcode_7038_Type",
            innerType: "70x38",
            Img: "https://eterp.in/static/media/38x25.63a937792710fd3fc847.png",
        },
    ];


    // GET SELECTED BARCODE FORMATS


    const selectedBarcodeFormats = useMemo(() => {
        return barcodeTypes.filter((barcode) =>
            Boolean(settings?.[barcode.key])
        );
    }, [settings]);


    // PASSWORD MODAL CLOSE


    const handlePasswordModalClose = () => {
        navigate(-1);
    };


    // PASSWORD VERIFY


    const handleVerifyPassword = () => {
        if (password === STATIC_PASSWORD) {
            setVerified(true);
            setPasswordModalOpen(false);
            setPasswordError("");
            return;
        }

        setPasswordError("Incorrect password");
    };


    // OPEN BARCODE DETAILS


    const handleOpenBarcode = (barcodeType) => {
        if (!verified) return;

        setSelectedBarcodeType(barcodeType);
        setBarcodeModalOpen(true);
    };


    // GET SELECTED BARCODE DETAIL


    const selectedBarcode = useMemo(() => {
        if (!selectedBarcodeType) return null;

        return (
            settings?.Inner_Prop?.find(
                (item) =>
                    item?.BarcodeType?.toLowerCase() ===
                    selectedBarcodeType?.innerType?.toLowerCase()
            ) || null
        );
    }, [settings, selectedBarcodeType]);


    // BARCODE SWITCH CHANGE
    //
    // IMPORTANT:
    // Multiple switches are allowed.


    const handleBarcodeEnabledChange = (
        selectedKey,
        checked
    ) => {
        if (!verified) return;

        setSettings((prev) => ({
            ...prev,
            [selectedKey]: checked,
        }));
    };


    // INNER PROP CHANGE


    const handleInnerPropChange = (field, value) => {
        if (!verified || !selectedBarcodeType) return;

        setSettings((prev) => ({
            ...prev,

            Inner_Prop: prev.Inner_Prop.map((item) => {
                if (
                    item?.BarcodeType?.toLowerCase() ===
                    selectedBarcodeType?.innerType?.toLowerCase()
                ) {
                    return {
                        ...item,
                        [field]: value,
                    };
                }

                return item;
            }),
        }));
    };


    // OPEN SUPPLIER FORMAT MODAL


    const handleOpenSupplierFormatModal = () => {
        if (!verified) return;

        if (selectedBarcodeFormats.length === 0) {
            showToast(
                "Please select at least one barcode format",
                "error"
            );
            return;
        }

        /*
         * If the previously selected supplier format is no longer
         * selected, reset it.
         */
        const isPreviousSelectionStillAvailable =
            selectedBarcodeFormats.some(
                (barcode) =>
                    barcode.innerType ===
                    selectedSupplierFormat
            );

        if (!isPreviousSelectionStillAvailable) {
            setSelectedSupplierFormat("");
        }

        setSupplierFormatModalOpen(true);
    };


    // SAVE BARCODE SETTINGS API


    const saveBarcodeSettings = async () => {
        const finalData = {
            Barcode_Type_3825: Boolean(
                settings?.App_Barcode_3825_Type
            ),

            Barcode_Type_5025: Boolean(
                settings?.App_Barcode_5025_Type
            ),

            Barcode_Type_5035: Boolean(
                settings?.App_Barcode_5035_Type
            ),

            Barcode_Type_5038: Boolean(
                settings?.App_Barcode_5038_Type
            ),

            Barcode_Type_6040: Boolean(
                settings?.App_Barcode_6040_Type
            ),

            Barcode_Type_7038: Boolean(
                settings?.App_Barcode_7038_Type
            ),

            barcode_Hide_WS_MRP_Rate: Boolean(
                settings?.barcode_Hide_WS_MRP_Rate
            ),

            barcodeSettingBody:
                settings?.Inner_Prop || [],
        };

        console.log(
            "FINAL BARCODE SETTINGS:",
            finalData
        );

        await dispatch(
            saveBarcodePrintSetting(finalData)
        ).unwrap();
    };


    // SAVE SUPPLIER FORMAT API


    const saveSupplierFormat = async (
        supplierFormat
    ) => {
        const myHeaders = new Headers();

        myHeaders.append(
            "Access-Control-Allow-Origin",
            "*"
        );

        myHeaders.append(
            "Content-Type",
            "application/json"
        );

        const rawData = CustomStringify({
            vendor_barcode_formate: supplierFormat,
        });

        const requestOptions = {
            method: "PATCH",
            headers: myHeaders,
            body: rawData,
            redirect: "follow",
        };

        const response = await fetch(
            `${API_URL}/sellers/${cmpdetail?.key}/${UserDetail?.result?.user?.id}`,
            requestOptions
        );

        const result = await response.json();

        console.log(
            "SUPPLIER FORMAT API RESPONSE:",
            result
        );

        if (result?.success !== true) {
            throw new Error(
                result?.message ||
                "Failed to save supplier format"
            );
        }

        return result;
    };


    // FINAL SAVE
    //
    // This runs only after user selects supplier format
    // and clicks Save inside supplier format dialog.


    const handleFinalSave = async () => {
        if (!selectedSupplierFormat) {
            showToast(
                "Please select supplier format",
                "error"
            );

            return;
        }

        try {
            setIsSaving(true);

            console.log(
                "SELECTED SUPPLIER FORMAT:",
                selectedSupplierFormat
            );

            // -------------------------------------------------
            // Update Redux user detail
            // -------------------------------------------------

            dispatch(
                editUserDetail({
                    name: "vendor_barcode_formate",
                    value: selectedSupplierFormat,
                })
            );

            // -------------------------------------------------
            // API 1 - Barcode settings
            // -------------------------------------------------

            await saveBarcodeSettings();

            // -------------------------------------------------
            // API 2 - Supplier format
            // -------------------------------------------------

            await saveSupplierFormat(
                selectedSupplierFormat
            );

            // -------------------------------------------------
            // SUCCESS
            // -------------------------------------------------

            showToast(
                "Saved successfully",
                "success"
            );

            setSupplierFormatModalOpen(false);

            setSelectedSupplierFormat("");

            navigate("/CompanyDashboard");
        } catch (error) {
            console.error(
                "FINAL SAVE ERROR:",
                error
            );

            showToast(
                error?.message ||
                "Failed to save settings",
                "error"
            );
        } finally {
            setIsSaving(false);
        }
    };


    // LOAD BARCODE SETTINGS FROM REDUX


    useEffect(() => {
        if (!barcodeSettings) return;

        setSettings((prevSettings) => {
            const defaultInnerProp =
                Array.isArray(
                    prevSettings?.Inner_Prop
                )
                    ? prevSettings.Inner_Prop
                    : [];

            const savedInnerProp =
                Array.isArray(
                    barcodeSettings?.Inner_Prop
                )
                    ? barcodeSettings.Inner_Prop
                    : [];

            const innerPropMap = new Map();

            // Defaults
            defaultInnerProp.forEach((item) => {
                if (item?.BarcodeType) {
                    innerPropMap.set(
                        item.BarcodeType,
                        item
                    );
                }
            });

            // Saved settings overwrite defaults
            savedInnerProp.forEach((item) => {
                if (item?.BarcodeType) {
                    innerPropMap.set(
                        item.BarcodeType,
                        item
                    );
                }
            });

            return {
                ...prevSettings,

                App_Barcode_3825_Type:
                    Boolean(
                        barcodeSettings?.Barcode_Type_3825
                    ),

                App_Barcode_5025_Type:
                    Boolean(
                        barcodeSettings?.Barcode_Type_5025
                    ),

                App_Barcode_5035_Type:
                    Boolean(
                        barcodeSettings?.Barcode_Type_5035
                    ),

                App_Barcode_5038_Type:
                    Boolean(
                        barcodeSettings?.Barcode_Type_5038
                    ),

                App_Barcode_6040_Type:
                    Boolean(
                        barcodeSettings?.Barcode_Type_6040
                    ),

                App_Barcode_7038_Type:
                    Boolean(
                        barcodeSettings?.Barcode_Type_7038
                    ),

                barcode_Hide_WS_MRP_Rate:
                    Boolean(
                        barcodeSettings?.barcode_Hide_WS_MRP_Rate
                    ),

                Inner_Prop:
                    Array.from(
                        innerPropMap.values()
                    ),
            };
        });
    }, [barcodeSettings]);


    // FETCH BARCODE SETTINGS


    useEffect(() => {
        dispatch(fetchBarcodePrintSetting());
    }, [dispatch]);


    // GET COMPANY SHORT NAME


    const getCompShortName = async () => {
        try {
            const res = await axios.get(
                "https://application.eterp.in/company/master"
            );

            const filtered = res.data.data.find((item) => item.key === cmpdetail?.key);
            console.log({ filtered })
            setSTATIC_PASSWORD(filtered?.mobile_no || "a")
            console.log(
                "COMPANY DETAILS:",
                filtered
            );
        } catch (err) {
            console.log(
                "COMPANY API ERROR:",
                err
            );
        }
    };

    useEffect(() => {
        getCompShortName();
    }, []);


    // return (
    //     <Box
    //         sx={{
    //             width: "100%",
    //             maxWidth: 700,
    //             minHeight: "100%",
    //             mx: "auto",
    //             p: { xs: 1.5, sm: 2, md: 3 },
    //             boxSizing: "border-box",
    //         }}
    //     >
    //         {/* HEADER */}
    //         <Stack
    //             direction="row"
    //             alignItems="center"
    //             justifyContent="space-between"
    //             mb={3}
    //         >
    //             <Box>
    //                 <Typography
    //                     variant="h5"
    //                     fontWeight={700}
    //                 >
    //                     Barcode Settings
    //                 </Typography>

    //                 <Typography
    //                     variant="body2"
    //                     color="text.secondary"
    //                 >
    //                     Configure barcode formats and
    //                     barcode content
    //                 </Typography>
    //             </Box>

    //             <LockIcon
    //                 color={
    //                     verified
    //                         ? "success"
    //                         : "disabled"
    //                 }
    //             />
    //         </Stack>

    //         {/* BARCODE TYPE LIST */}

    //         <Paper
    //             elevation={2}
    //             sx={{
    //                 p: 2,
    //                 borderRadius: 2,
    //             }}
    //         >
    //             <Stack spacing={1}>
    //                 {barcodeTypes.map((barcode) => {
    //                     const enabled =
    //                         settings?.[barcode.key];

    //                     return (
    //                         <Box
    //                             key={barcode.key}
    //                             sx={{
    //                                 display: "flex",
    //                                 alignItems: "center",
    //                                 justifyContent:
    //                                     "space-between",
    //                                 px: 1.5,
    //                                 py: 1,
    //                                 border:
    //                                     "1px solid #e0e0e0",
    //                                 borderRadius: 1.5,

    //                                 "&:hover": {
    //                                     backgroundColor:
    //                                         "#fafafa",
    //                                 },
    //                             }}
    //                         >
    //                             <FormControlLabel
    //                                 control={
    //                                     <Switch
    //                                         checked={Boolean(
    //                                             enabled
    //                                         )}
    //                                         disabled={
    //                                             !verified
    //                                         }
    //                                         onChange={(e) =>
    //                                             handleBarcodeEnabledChange(
    //                                                 barcode.key,
    //                                                 e.target
    //                                                     .checked
    //                                             )
    //                                         }
    //                                         color="primary"
    //                                     />
    //                                 }
    //                                 label={
    //                                     <Typography
    //                                         fontWeight={
    //                                             600
    //                                         }
    //                                     >
    //                                         {
    //                                             barcode.label
    //                                         }
    //                                     </Typography>
    //                                 }
    //                             />

    //                             <IconButton
    //                                 size="small"
    //                                 disabled={
    //                                     !verified
    //                                 }
    //                                 onClick={() =>
    //                                     handleOpenBarcode(
    //                                         barcode
    //                                     )
    //                                 }
    //                             >
    //                                 {UserDetail?.result?.user?.vendor_barcode_formate?.toLowerCase() == barcode?.innerType
    //                                     &&
    //                                     <CheckCircleIcon sx={{ color: "#369b22", fontSize: 24 }} />
    //                                 }
    //                                 <VisibilityIcon />
    //                             </IconButton>
    //                         </Box>
    //                     );
    //                 })}
    //             </Stack>
    //         </Paper>


    //         {/* SELECTED COUNT */}


    //         {verified && (
    //             <Typography
    //                 variant="body2"
    //                 color="text.secondary"
    //                 sx={{ mt: 1 }}
    //             >
    //                 {selectedBarcodeFormats.length}{" "}
    //                 barcode format
    //                 {selectedBarcodeFormats.length !==
    //                     1
    //                     ? "s"
    //                     : ""}{" "}
    //                 selected
    //             </Typography>
    //         )}


    //         {/* FIRST SAVE BUTTON */}


    //         <Stack
    //             direction="row"
    //             justifyContent="flex-end"
    //             mt={3}
    //         >
    //             <Button
    //                 variant="contained"
    //                 startIcon={<SaveIcon />}
    //                 disabled={
    //                     !verified ||
    //                     selectedBarcodeFormats.length ===
    //                     0
    //                 }
    //                 onClick={
    //                     handleOpenSupplierFormatModal
    //                 }
    //             >
    //                 Save Settings
    //             </Button>
    //         </Stack>


    //         {/* PASSWORD DIALOG */}


    //         <Dialog
    //             open={passwordModalOpen}
    //             disableEscapeKeyDown
    //             onClose={
    //                 handlePasswordModalClose
    //             }
    //             maxWidth={false}
    //             fullWidth
    //             PaperProps={{
    //                 sx: {
    //                     width: "360px",
    //                     maxWidth:
    //                         "calc(100% - 32px)",
    //                     borderRadius: "18px",
    //                     overflow: "hidden",
    //                     boxShadow:
    //                         "0 24px 70px rgba(0,0,0,0.25)",
    //                 },
    //             }}
    //             sx={{
    //                 "& .MuiBackdrop-root": {
    //                     backgroundColor:
    //                         "rgba(0, 0, 0, 0.30)",
    //                     backdropFilter:
    //                         "blur(10px)",
    //                     WebkitBackdropFilter:
    //                         "blur(10px)",
    //                 },
    //             }}
    //         >
    //             {/* HEADER */}

    //             <Box
    //                 sx={{
    //                     px: 2,
    //                     pt: 2,
    //                     pb: 1,
    //                     position: "relative",
    //                 }}
    //             >
    //                 <Stack
    //                     direction="row"
    //                     alignItems="center"
    //                     spacing={1.2}
    //                 >
    //                     <Box
    //                         sx={{
    //                             width: 38,
    //                             height: 38,
    //                             borderRadius: "11px",
    //                             display: "flex",
    //                             alignItems:
    //                                 "center",
    //                             justifyContent:
    //                                 "center",
    //                             background:
    //                                 "linear-gradient(135deg, #1976d2, #42a5f5)",
    //                             color: "#fff",
    //                             boxShadow:
    //                                 "0 5px 15px rgba(25,118,210,0.25)",
    //                         }}
    //                     >
    //                         <LockIcon fontSize="small" />
    //                     </Box>

    //                     <Box>
    //                         <Typography
    //                             sx={{
    //                                 fontSize: 17,
    //                                 fontWeight: 700,
    //                                 lineHeight: 1.2,
    //                             }}
    //                         >
    //                             Verify Password
    //                         </Typography>

    //                         <Typography
    //                             sx={{
    //                                 fontSize: 11.5,
    //                                 color: "text.secondary",
    //                                 mt: 0.3,
    //                             }}
    //                         >
    //                             Barcode Settings
    //                         </Typography>
    //                     </Box>
    //                 </Stack>

    //                 <IconButton
    //                     aria-label="close"
    //                     onClick={
    //                         handlePasswordModalClose
    //                     }
    //                     size="small"
    //                     sx={{
    //                         position:
    //                             "absolute",
    //                         right: 10,
    //                         top: 10,
    //                         width: 30,
    //                         height: 30,
    //                         color: "text.secondary",

    //                         "&:hover": {
    //                             backgroundColor:
    //                                 "rgba(0,0,0,0.06)",
    //                             color: "error.main",
    //                         },
    //                     }}
    //                 >
    //                     <CloseIcon fontSize="small" />
    //                 </IconButton>
    //             </Box>

    //             {/* CONTENT */}

    //             <DialogContent
    //                 sx={{
    //                     px: 2,
    //                     pt: 1,
    //                     pb: 2,
    //                 }}
    //             >
    //                 <Typography
    //                     sx={{
    //                         fontSize: 12.5,
    //                         color: "text.secondary",
    //                         mb: 1.8,
    //                         lineHeight: 1.5,
    //                     }}
    //                 >
    //                     Enter the password to
    //                     access barcode settings.
    //                 </Typography>

    //                 {/* PASSWORD */}

    //                 <TextField
    //                     fullWidth
    //                     autoFocus
    //                     size="small"
    //                     type={
    //                         showPassword
    //                             ? "text"
    //                             : "password"
    //                     }
    //                     label="Password"
    //                     placeholder="Enter password"
    //                     value={password}
    //                     error={Boolean(
    //                         passwordError
    //                     )}
    //                     helperText={
    //                         passwordError
    //                     }
    //                     onChange={(e) => {
    //                         setPassword(
    //                             e.target.value
    //                         );
    //                         setPasswordError("");
    //                     }}
    //                     onKeyDown={(e) => {
    //                         if (
    //                             e.key ===
    //                             "Enter"
    //                         ) {
    //                             handleVerifyPassword();
    //                         }
    //                     }}
    //                     slotProps={{
    //                         input: {
    //                             endAdornment: (
    //                                 <InputAdornment position="end">
    //                                     <IconButton
    //                                         size="small"
    //                                         edge="end"
    //                                         onClick={() =>
    //                                             setShowPassword(
    //                                                 (prev) =>
    //                                                     !prev
    //                                             )
    //                                         }
    //                                     >
    //                                         {showPassword ? (
    //                                             <VisibilityOffIcon fontSize="small" />
    //                                         ) : (
    //                                             <VisibilityIcon fontSize="small" />
    //                                         )}
    //                                     </IconButton>
    //                                 </InputAdornment>
    //                             ),
    //                         },
    //                     }}
    //                     sx={{
    //                         "& .MuiOutlinedInput-root":
    //                         {
    //                             borderRadius:
    //                                 "10px",
    //                             backgroundColor:
    //                                 "#fafafa",
    //                         },

    //                         "& .MuiFormHelperText-root":
    //                         {
    //                             marginLeft: 0,
    //                             fontSize: 11,
    //                         },
    //                     }}
    //                 />

    //                 {/* VERIFY */}

    //                 <Button
    //                     fullWidth
    //                     variant="contained"
    //                     onClick={
    //                         handleVerifyPassword
    //                     }
    //                     sx={{
    //                         mt: 2,
    //                         height: 40,
    //                         borderRadius: "10px",
    //                         textTransform:
    //                             "none",
    //                         fontSize: 14,
    //                         fontWeight: 600,

    //                         background:
    //                             "linear-gradient(135deg, #1976d2, #1565c0)",

    //                         boxShadow:
    //                             "0 5px 15px rgba(25,118,210,0.25)",

    //                         "&:hover": {
    //                             background:
    //                                 "linear-gradient(135deg, #1565c0, #0d47a1)",
    //                             boxShadow:
    //                                 "0 7px 18px rgba(25,118,210,0.3)",
    //                         },
    //                     }}
    //                 >
    //                     Verify
    //                 </Button>
    //             </DialogContent>
    //         </Dialog>


    //         {/* SUPPLIER FORMAT DIALOG */}


    //         <Dialog
    //             open={supplierFormatModalOpen}
    //             onClose={() => {
    //                 if (!isSaving) {
    //                     setSupplierFormatModalOpen(
    //                         false
    //                     );
    //                 }
    //             }}
    //             maxWidth="xs"
    //             fullWidth
    //             PaperProps={{
    //                 sx: {
    //                     borderRadius: 2,
    //                 },
    //             }}
    //         >
    //             <DialogTitle
    //                 sx={{
    //                     borderBottom:
    //                         "1px solid #e0e0e0",
    //                 }}
    //             >
    //                 <Stack
    //                     direction="row"
    //                     alignItems="center"
    //                     justifyContent="space-between"
    //                 >
    //                     <Typography
    //                         fontWeight={600}
    //                     >
    //                         Select Supplier Format
    //                     </Typography>

    //                     <IconButton
    //                         size="small"
    //                         disabled={isSaving}
    //                         onClick={() =>
    //                             setSupplierFormatModalOpen(
    //                                 false
    //                             )
    //                         }
    //                     >
    //                         <CloseIcon />
    //                     </IconButton>
    //                 </Stack>
    //             </DialogTitle>

    //             <DialogContent
    //                 sx={{ pt: 3 }}
    //             >
    //                 <Typography
    //                     variant="body2"
    //                     color="text.secondary"
    //                     sx={{ mb: 2 }}
    //                 >
    //                     You selected{" "}
    //                     <strong>
    //                         {
    //                             selectedBarcodeFormats.length
    //                         }
    //                     </strong>{" "}
    //                     barcode formats. Select
    //                     one format to use as the
    //                     supplier barcode format.
    //                 </Typography>

    //                 {/* SELECTED FORMATS */}

    //                 <Box
    //                     sx={{
    //                         mb: 2,
    //                         p: 1.5,
    //                         backgroundColor:
    //                             "#f7f9fc",
    //                         borderRadius: 1.5,
    //                         border:
    //                             "1px solid #e3e8ef",
    //                     }}
    //                 >
    //                     <Typography
    //                         variant="caption"
    //                         color="text.secondary"
    //                     >
    //                         Enabled formats
    //                     </Typography>

    //                     <Stack
    //                         direction="row"
    //                         flexWrap="wrap"
    //                         gap={0.8}
    //                         mt={1}
    //                     >
    //                         {selectedBarcodeFormats.map(
    //                             (barcode) => (
    //                                 <Box
    //                                     key={
    //                                         barcode.key
    //                                     }
    //                                     sx={{
    //                                         px: 1,
    //                                         py: 0.5,
    //                                         borderRadius:
    //                                             1,
    //                                         backgroundColor:
    //                                             "#e3f2fd",
    //                                         color:
    //                                             "#1565c0",
    //                                         fontSize: 12,
    //                                         fontWeight: 600,
    //                                     }}
    //                                 >
    //                                     {
    //                                         barcode.label
    //                                     }
    //                                 </Box>
    //                             )
    //                         )}
    //                     </Stack>
    //                 </Box>

    //                 {/* SUPPLIER FORMAT */}

    //                 <FormControl
    //                     fullWidth
    //                     size="small"
    //                 >
    //                     <InputLabel>
    //                         Supplier Format
    //                     </InputLabel>

    //                     <Select
    //                         value={selectedSupplierFormat}
    //                         label="Supplier Format"
    //                         onChange={(e) =>
    //                             setSelectedSupplierFormat(
    //                                 e.target
    //                                     .value
    //                             )
    //                         }
    //                     >
    //                         {selectedBarcodeFormats.map(
    //                             (barcode) => (
    //                                 <MenuItem
    //                                     key={
    //                                         barcode.key
    //                                     }
    //                                     value={
    //                                         barcode.innerType
    //                                     }
    //                                 >
    //                                     {
    //                                         barcode.label
    //                                     }
    //                                 </MenuItem>
    //                             )
    //                         )}
    //                     </Select>
    //                 </FormControl>
    //             </DialogContent>

    //             <DialogActions
    //                 sx={{
    //                     px: 3,
    //                     py: 2,
    //                     borderTop:
    //                         "1px solid #e0e0e0",
    //                 }}
    //             >
    //                 <Button
    //                     onClick={() => {
    //                         setSupplierFormatModalOpen(
    //                             false
    //                         );
    //                         setSelectedSupplierFormat(
    //                             ""
    //                         );
    //                     }}
    //                     disabled={isSaving}
    //                 >
    //                     Cancel
    //                 </Button>

    //                 <Button
    //                     variant="contained"
    //                     startIcon={
    //                         <SaveIcon />
    //                     }
    //                     disabled={
    //                         !selectedSupplierFormat ||
    //                         isSaving
    //                     }
    //                     onClick={
    //                         handleFinalSave
    //                     }
    //                 >
    //                     {isSaving
    //                         ? "Saving..."
    //                         : "Save"}
    //                 </Button>
    //             </DialogActions>
    //         </Dialog>


    //         {/* BARCODE DETAIL DIALOG */}


    //         <Dialog
    //             open={barcodeModalOpen}
    //             onClose={() =>
    //                 setBarcodeModalOpen(false)
    //             }
    //             maxWidth={false}
    //             fullWidth
    //             PaperProps={{
    //                 sx: {
    //                     width: { xs: "calc(100% - 16px)", sm: "96%", md: "98%" },
    //                     maxWidth: "1125px",
    //                     maxHeight: "calc(100vh - 32px)",
    //                     borderRadius: "4px",
    //                     m: 1,
    //                     overflow: "hidden",
    //                 },
    //             }}
    //         >
    //             <DialogTitle
    //                 sx={{
    //                     px: 3,
    //                     py: 1.2,
    //                     borderBottom:
    //                         "1px solid #ddd",
    //                 }}
    //             >
    //                 <Stack
    //                     direction="row"
    //                     alignItems="center"
    //                     justifyContent="space-between"
    //                 >
    //                     <Stack
    //                         direction="row"
    //                         alignItems="center"
    //                         spacing={1}
    //                     >
    //                         <Typography
    //                             sx={{
    //                                 fontSize:
    //                                     "20px",
    //                                 fontWeight: 600,
    //                                 color: "#333",
    //                             }}
    //                         >
    //                             Fill Dynamic Content -{" "}
    //                             {
    //                                 selectedBarcodeType?.label
    //                             }
    //                         </Typography>

    //                         <IconButton
    //                             size="small"
    //                             onClick={() =>
    //                                 setBarcodePreviewOpen(
    //                                     true
    //                                 )
    //                             }
    //                             title="Preview Barcode"
    //                             sx={{
    //                                 ml: 0.5,
    //                                 color: "#4d9bd5",

    //                                 "&:hover":
    //                                 {
    //                                     backgroundColor:
    //                                         "rgba(77, 155, 213, 0.1)",
    //                                     color: "#1976d2",
    //                                 },
    //                             }}
    //                         >

    //                             <VisibilityIcon sx={{ fontSize: 21, }} />
    //                         </IconButton>
    //                     </Stack>

    //                     <IconButton
    //                         size="small"
    //                         onClick={() =>
    //                             setBarcodeModalOpen(
    //                                 false
    //                             )
    //                         }
    //                     >
    //                         <CloseIcon />
    //                     </IconButton>
    //                 </Stack>
    //             </DialogTitle>

    //             <DialogContent
    //                 sx={{
    //                     px: { xs: 1.5, sm: 2, md: 3 },
    //                     py: 2,
    //                     overflowX: "hidden",
    //                     overflowY: "auto",
    //                     minHeight: 0,
    //                     boxSizing: "border-box",
    //                 }}
    //             >
    //                 {selectedBarcode && (
    //                     <Box
    //                         sx={{
    //                             width: "100%",
    //                         }}
    //                     >
    //                         {/* TOP SETTINGS */}

    //                         <Box
    //                             sx={{
    //                                 display:
    //                                     "grid",
    //                                 gridTemplateColumns:
    //                                 {
    //                                     xs: "1fr",
    //                                     sm: "1fr",
    //                                     md: "260px 1fr 240px",
    //                                     lg: "260px 1fr 240px",
    //                                 },
    //                                 gap: 1.2,
    //                                 alignItems:
    //                                     "center",
    //                                 my: 3,
    //                             }}
    //                         >
    //                             <TextField
    //                                 size="small"
    //                                 fullWidth
    //                                 placeholder="Set Qty Caption"
    //                                 value={
    //                                     selectedBarcode?.Barcode_SetQtyCaption ||
    //                                     ""
    //                                 }
    //                                 onChange={(
    //                                     e
    //                                 ) =>
    //                                     handleInnerPropChange(
    //                                         "Barcode_SetQtyCaption",
    //                                         e.target
    //                                             .value
    //                                     )
    //                                 }
    //                                 sx={{
    //                                     "& .MuiOutlinedInput-root":
    //                                     {
    //                                         height: 35,
    //                                     },
    //                                 }}
    //                             />

    //                             <FormControl
    //                                 size="small"
    //                                 fullWidth
    //                             >
    //                                 <InputLabel>
    //                                     Format Type
    //                                 </InputLabel>

    //                                 <Select
    //                                     value={
    //                                         selectedBarcode?.BarcodeFormat ||
    //                                         ""
    //                                     }
    //                                     label="Format Type"
    //                                     onChange={(
    //                                         e
    //                                     ) =>
    //                                         handleInnerPropChange(
    //                                             "BarcodeFormat",
    //                                             e.target
    //                                                 .value
    //                                         )
    //                                     }
    //                                     sx={{
    //                                         height: 35,
    //                                     }}
    //                                 >
    //                                     <MenuItem value="Format 1 - Barcode Line">
    //                                         Format 1 -
    //                                         Barcode
    //                                         Line
    //                                     </MenuItem>

    //                                     <MenuItem value="Format 2 - QR Code">
    //                                         Format 2 -
    //                                         QR Code
    //                                     </MenuItem>
    //                                 </Select>
    //                             </FormControl>

    //                             <Stack
    //                                 direction="row"
    //                                 alignItems="center"
    //                                 spacing={
    //                                     0.5
    //                                 }
    //                             >
    //                                 <Checkbox
    //                                     checked={Boolean(
    //                                         selectedBarcode?.Barcode_With_Currency
    //                                     )}
    //                                     onChange={(
    //                                         e
    //                                     ) =>
    //                                         handleInnerPropChange(
    //                                             "Barcode_With_Currency",
    //                                             e
    //                                                 .target
    //                                                 .checked
    //                                         )
    //                                     }
    //                                     size="small"
    //                                     sx={{
    //                                         p: 0.3,
    //                                     }}
    //                                 />

    //                                 <Typography
    //                                     sx={{
    //                                         fontSize: 14,
    //                                         whiteSpace:
    //                                             "nowrap",
    //                                     }}
    //                                 >
    //                                     With Currency
    //                                 </Typography>
    //                             </Stack>
    //                         </Box>

    //                         {/* CONTENT FIELDS */}

    //                         <Box
    //                             sx={{
    //                                 display:
    //                                     "grid",
    //                                 gridTemplateColumns:
    //                                 {
    //                                     xs: "1fr",
    //                                     sm: "repeat(2, minmax(0, 1fr))",
    //                                     md: "repeat(3, minmax(0, 1fr))",
    //                                     lg: "repeat(6, minmax(0, 1fr))",
    //                                 },
    //                                 gap: 1,
    //                             }}
    //                         >
    //                             {[1, 2, 3, 4, 5, 6].map(
    //                                 (index) => {
    //                                     const contentField = `Barcode_Content${index}`;

    //                                     const fontField = `Barcode_ContentFont${index}`;

    //                                     const currentValue =
    //                                         selectedBarcode?.[
    //                                         contentField
    //                                         ] || "";

    //                                     return (
    //                                         <Box
    //                                             key={
    //                                                 index
    //                                             }
    //                                             sx={{
    //                                                 minWidth: 0,
    //                                                 width: "100%"
    //                                             }}
    //                                         >
    //                                             <FormControl
    //                                                 fullWidth
    //                                                 size="small"
    //                                                 sx={{
    //                                                     mb: 0.8,
    //                                                 }}
    //                                             >
    //                                                 <InputLabel>
    //                                                     {`Content ${index}`}
    //                                                 </InputLabel>

    //                                                 <Select
    //                                                     value={
    //                                                         currentValue
    //                                                     }
    //                                                     label={`Content ${index}`}
    //                                                     onChange={(
    //                                                         e
    //                                                     ) =>
    //                                                         handleInnerPropChange(
    //                                                             contentField,
    //                                                             e
    //                                                                 .target
    //                                                                 .value
    //                                                         )
    //                                                     }
    //                                                     sx={{
    //                                                         height: 35,
    //                                                         fontSize: 13,
    //                                                     }}
    //                                                 >
    //                                                     <MenuItem value="">
    //                                                         <em>
    //                                                             None
    //                                                         </em>
    //                                                     </MenuItem>

    //                                                     {[
    //                                                         "Design",
    //                                                         "Color",
    //                                                         "Design Group",
    //                                                         "Product",
    //                                                         "Pattern",
    //                                                         "Size",
    //                                                         "Comp. ShortName",
    //                                                         "WS Rate 1",
    //                                                         "MRP Rate 1",
    //                                                         "Department",
    //                                                     ].map(
    //                                                         (
    //                                                             option
    //                                                         ) => (
    //                                                             <MenuItem
    //                                                                 key={
    //                                                                     option
    //                                                                 }
    //                                                                 value={
    //                                                                     option
    //                                                                 }
    //                                                             >
    //                                                                 {
    //                                                                     option
    //                                                                 }
    //                                                             </MenuItem>
    //                                                         )
    //                                                     )}
    //                                                 </Select>
    //                                             </FormControl>

    //                                             <TextField
    //                                                 fullWidth
    //                                                 size="small"
    //                                                 placeholder="FontSize"
    //                                                 value={
    //                                                     selectedBarcode?.[
    //                                                     fontField
    //                                                     ] ||
    //                                                     ""
    //                                                 }
    //                                                 onChange={(
    //                                                     e
    //                                                 ) =>
    //                                                     handleInnerPropChange(
    //                                                         fontField,
    //                                                         e
    //                                                             .target
    //                                                             .value
    //                                                     )
    //                                                 }
    //                                                 sx={{
    //                                                     "& .MuiOutlinedInput-root":
    //                                                     {
    //                                                         height: 35,
    //                                                     },

    //                                                     "& input":
    //                                                     {
    //                                                         fontSize: 13,
    //                                                     },
    //                                                 }}
    //                                             />
    //                                         </Box>
    //                                     );
    //                                 }
    //                             )}
    //                         </Box>
    //                     </Box>
    //                 )}
    //             </DialogContent>

    //             <DialogActions
    //                 sx={{
    //                     px: 3,
    //                     py: 0.8,
    //                     justifyContent:
    //                         "flex-end",
    //                     borderTop:
    //                         "1px solid #ddd",
    //                 }}
    //             >
    //                 <Button
    //                     variant="contained"
    //                     onClick={() =>
    //                         setBarcodeModalOpen(
    //                             false
    //                         )
    //                     }
    //                     sx={{
    //                         minWidth: 64,
    //                         height: 28,
    //                         textTransform:
    //                             "none",
    //                         fontSize: 13,
    //                         py: 0,
    //                     }}
    //                 >
    //                     OK
    //                 </Button>
    //             </DialogActions>


    //             {/* BARCODE PREVIEW */}


    //             <Dialog
    //                 open={barcodePreviewOpen}
    //                 onClose={() =>
    //                     setBarcodePreviewOpen(
    //                         false
    //                     )
    //                 }
    //                 maxWidth={false}
    //                 PaperProps={{
    //                     sx: {
    //                         width: {
    //                             xs: "calc(100vw - 16px)",
    //                             sm: "fit-content",
    //                         },
    //                         maxWidth: "calc(100vw - 16px)",
    //                         maxHeight: "calc(100vh - 16px)",
    //                         m: 2,
    //                         borderRadius: 2,
    //                         overflow: "hidden",
    //                         boxShadow:
    //                             "0 20px 60px rgba(0,0,0,0.3)",
    //                     },
    //                 }}
    //             >
    //                 {/* HEADER */}

    //                 <Box
    //                     sx={{
    //                         display: "flex",
    //                         alignItems:
    //                             "center",
    //                         justifyContent:
    //                             "space-between",
    //                         px: 1.5,
    //                         py: 1,
    //                         borderBottom:
    //                             "1px solid #e0e0e0",
    //                         backgroundColor:
    //                             "#fff",
    //                     }}
    //                 >
    //                     <Typography
    //                         sx={{
    //                             fontSize: 15,
    //                             fontWeight: 600,
    //                         }}
    //                     >
    //                         {
    //                             selectedBarcodeType?.label
    //                         }{" "}
    //                         Preview
    //                     </Typography>

    //                     <IconButton
    //                         size="small"
    //                         onClick={() =>
    //                             setBarcodePreviewOpen(
    //                                 false
    //                             )
    //                         }
    //                     >
    //                         <CloseIcon fontSize="small" />
    //                     </IconButton>
    //                 </Box>

    //                 {/* IMAGE */}

    //                 <Box
    //                     sx={{
    //                         display: "flex",
    //                         alignItems:
    //                             "center",
    //                         justifyContent:
    //                             "center",
    //                         backgroundColor:
    //                             "#f5f5f5",
    //                         p: 1,
    //                         overflow: "auto",
    //                     }}
    //                 >
    //                     {selectedBarcodeType?.Img && (
    //                         <Box
    //                             component="img"
    //                             src={
    //                                 selectedBarcodeType.Img
    //                             }
    //                             alt={`${selectedBarcodeType.label} barcode preview`}
    //                             sx={{
    //                                 display:
    //                                     "block",
    //                                 width: "auto",
    //                                 height: "auto",
    //                                 maxWidth: "100%",
    //                                 maxHeight: "calc(100vh - 100px)",
    //                                 objectFit: "contain",
    //                             }}
    //                         />
    //                     )}
    //                 </Box>
    //             </Dialog>
    //         </Dialog>
    //     </Box>
    // );

    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: 700,
                minHeight: "100%",
                height: "auto",
                mx: "auto",
                p: { xs: 1.5, sm: 2, md: 3 },
                boxSizing: "border-box",
            }}
        >
            {/* HEADER */}
            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                mb={1}
                gap={2}
            >
                <Box sx={{ minWidth: 0 }}>
                    <Typography
                        variant="h5"
                        fontWeight={700}
                        sx={{
                            fontSize: { xs: 20, sm: 24 },
                        }}
                    >
                        Barcode Settings
                    </Typography>

                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{
                            fontSize: { xs: 11, sm: 14 },
                        }}
                    >
                        Configure barcode formats and barcode content
                    </Typography>
                </Box>

                <LockIcon
                    color={verified ? "success" : "disabled"}
                    sx={{ flexShrink: 0 }}
                />
            </Stack>

            {/* BARCODE TYPE LIST */}
            <Paper
                elevation={2}
                sx={{
                    p: { xs: 1, sm: 2 },
                    borderRadius: 2,
                    width: "100%",
                    boxSizing: "border-box",
                    py: 0
                }}
            >
                <Stack spacing={1}>
                    {barcodeTypes.map((barcode) => {
                        const enabled = settings?.[barcode.key];

                        return (
                            <Box
                                key={barcode.key}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    gap: 1,
                                    px: { xs: 1, sm: 1.5 },

                                    border: "1px solid #e0e0e0",
                                    borderRadius: 1.5,
                                    minWidth: 0,

                                    "&:hover": {
                                        backgroundColor: "#fafafa",
                                    },
                                }}
                            >
                                <FormControlLabel
                                    sx={{
                                        m: 0,
                                        minWidth: 0,
                                        flex: 1,
                                    }}
                                    control={
                                        <Switch
                                            checked={Boolean(enabled)}
                                            disabled={!verified}
                                            onChange={(e) =>
                                                handleBarcodeEnabledChange(
                                                    barcode.key,
                                                    e.target.checked
                                                )
                                            }
                                            color="primary"
                                        />
                                    }
                                    label={
                                        <Typography
                                            fontWeight={600}
                                            sx={{
                                                fontSize: {
                                                    xs: 13,
                                                    sm: 14,
                                                },
                                            }}
                                        >
                                            {barcode.label}
                                        </Typography>
                                    }
                                />

                                <IconButton
                                    size="small"
                                    disabled={!verified}
                                    onClick={() =>
                                        handleOpenBarcode(barcode)
                                    }
                                    sx={{
                                        flexShrink: 0,
                                    }}
                                >
                                    {UserDetail?.result?.user?.vendor_barcode_formate?.toLowerCase() ===
                                        barcode?.innerType && (
                                            <CheckCircleIcon
                                                sx={{
                                                    color: "#369b22",
                                                    fontSize: 24,
                                                }}
                                            />
                                        )}

                                    <VisibilityIcon />
                                </IconButton>
                            </Box>
                        );
                    })}
                </Stack>
            </Paper>

            {/* SELECTED COUNT */}
            {verified && (
                <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{
                        mt: 1,
                        fontSize: { xs: 11, sm: 14 },
                    }}
                >
                    {selectedBarcodeFormats.length} barcode format
                    {selectedBarcodeFormats.length !== 1 ? "s" : ""} selected
                </Typography>
            )}

            {/* SAVE BUTTON */}
            <Stack
                direction="row"
                justifyContent="flex-end"
                mt={0}
            >
                <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    disabled={
                        !verified ||
                        selectedBarcodeFormats.length === 0
                    }
                    onClick={handleOpenSupplierFormatModal}
                    sx={{
                        width: { xs: "100%", sm: "auto" },
                    }}
                >
                    Save Settings
                </Button>
            </Stack>

            {/* PASSWORD DIALOG */}
            <Dialog
                open={passwordModalOpen}
                disableEscapeKeyDown
                onClose={handlePasswordModalClose}
                maxWidth={false}
                fullWidth
                PaperProps={{
                    sx: {
                        width: "360px",
                        maxWidth: "calc(100% - 32px)",
                        borderRadius: "18px",
                        overflow: "hidden",
                        boxShadow: "0 24px 70px rgba(0,0,0,0.25)",
                    },
                }}
                sx={{
                    "& .MuiBackdrop-root": {
                        backgroundColor: "rgba(0, 0, 0, 0.30)",
                        backdropFilter: "blur(10px)",
                        WebkitBackdropFilter: "blur(10px)",
                    },
                }}
            >
                {/* HEADER */}
                <Box
                    sx={{
                        px: 2,
                        pt: 2,
                        pb: 1,
                        position: "relative",
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        spacing={1.2}
                    >
                        <Box
                            sx={{
                                width: 38,
                                height: 38,
                                borderRadius: "11px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background:
                                    "linear-gradient(135deg, #1976d2, #42a5f5)",
                                color: "#fff",
                                boxShadow:
                                    "0 5px 15px rgba(25,118,210,0.25)",
                                flexShrink: 0,
                            }}
                        >
                            <LockIcon fontSize="small" />
                        </Box>

                        <Box sx={{ minWidth: 0 }}>
                            <Typography
                                sx={{
                                    fontSize: 17,
                                    fontWeight: 700,
                                    lineHeight: 1.2,
                                }}
                            >
                                Verify Password
                            </Typography>

                            <Typography
                                sx={{
                                    fontSize: 11.5,
                                    color: "text.secondary",
                                    mt: 0.3,
                                }}
                            >
                                Barcode Settings
                            </Typography>
                        </Box>
                    </Stack>

                    <IconButton
                        aria-label="close"
                        onClick={handlePasswordModalClose}
                        size="small"
                        sx={{
                            position: "absolute",
                            right: 10,
                            top: 10,
                            width: 30,
                            height: 30,
                            color: "text.secondary",

                            "&:hover": {
                                backgroundColor: "rgba(0,0,0,0.06)",
                                color: "error.main",
                            },
                        }}
                    >
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>

                {/* CONTENT */}
                <DialogContent
                    sx={{
                        px: 2,
                        pt: 1,
                        pb: 2,
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: 12.5,
                            color: "text.secondary",
                            mb: 1.8,
                            lineHeight: 1.5,
                        }}
                    >
                        Enter the password to access barcode settings.
                    </Typography>

                    <TextField
                        fullWidth
                        autoFocus
                        size="small"
                        type={showPassword ? "text" : "password"}
                        label="Password"
                        placeholder="Enter password"
                        value={password}
                        error={Boolean(passwordError)}
                        helperText={passwordError}
                        onChange={(e) => {
                            setPassword(e.target.value);
                            setPasswordError("");
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleVerifyPassword();
                            }
                        }}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton
                                            size="small"
                                            edge="end"
                                            onClick={() =>
                                                setShowPassword(
                                                    (prev) => !prev
                                                )
                                            }
                                        >
                                            {showPassword ? (
                                                <VisibilityOffIcon fontSize="small" />
                                            ) : (
                                                <VisibilityIcon fontSize="small" />
                                            )}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                            },
                        }}
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "10px",
                                backgroundColor: "#fafafa",
                            },

                            "& .MuiFormHelperText-root": {
                                marginLeft: 0,
                                fontSize: 11,
                            },
                        }}
                    />

                    <Button
                        fullWidth
                        variant="contained"
                        onClick={handleVerifyPassword}
                        sx={{
                            mt: 2,
                            height: 40,
                            borderRadius: "10px",
                            textTransform: "none",
                            fontSize: 14,
                            fontWeight: 600,
                            background:
                                "linear-gradient(135deg, #1976d2, #1565c0)",
                            boxShadow:
                                "0 5px 15px rgba(25,118,210,0.25)",

                            "&:hover": {
                                background:
                                    "linear-gradient(135deg, #1565c0, #0d47a1)",
                                boxShadow:
                                    "0 7px 18px rgba(25,118,210,0.3)",
                            },
                        }}
                    >
                        Verify
                    </Button>
                </DialogContent>
            </Dialog>

            {/* SUPPLIER FORMAT DIALOG */}
            <Dialog
                open={supplierFormatModalOpen}
                onClose={() => {
                    if (!isSaving) {
                        setSupplierFormatModalOpen(false);
                    }
                }}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 2,
                        width: "100%",
                        maxWidth: 500,
                        m: 1,
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        borderBottom: "1px solid #e0e0e0",
                        px: { xs: 2, sm: 3 },
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={1}
                    >
                        <Typography
                            fontWeight={600}
                            sx={{
                                fontSize: { xs: 15, sm: 16 },
                            }}
                        >
                            Select Supplier Format
                        </Typography>

                        <IconButton
                            size="small"
                            disabled={isSaving}
                            onClick={() =>
                                setSupplierFormatModalOpen(false)
                            }
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </DialogTitle>

                <DialogContent
                    sx={{
                        pt: 3,
                        px: { xs: 2, sm: 3 },
                    }}
                >
                    <Typography
                        variant="body2"
                        color="text.secondary"
                        sx={{ mb: 2 }}
                    >
                        You selected{" "}
                        <strong>{selectedBarcodeFormats.length}</strong>{" "}
                        barcode formats. Select one format to use as the
                        supplier barcode format.
                    </Typography>

                    <Box
                        sx={{
                            mb: 2,
                            p: 1.5,
                            backgroundColor: "#f7f9fc",
                            borderRadius: 1.5,
                            border: "1px solid #e3e8ef",
                        }}
                    >
                        <Typography
                            variant="caption"
                            color="text.secondary"
                        >
                            Enabled formats
                        </Typography>

                        <Stack
                            direction="row"
                            flexWrap="wrap"
                            gap={0.8}
                            mt={1}
                        >
                            {selectedBarcodeFormats.map((barcode) => (
                                <Box
                                    key={barcode.key}
                                    sx={{
                                        px: 1,
                                        py: 0.5,
                                        borderRadius: 1,
                                        backgroundColor: "#e3f2fd",
                                        color: "#1565c0",
                                        fontSize: 12,
                                        fontWeight: 600,
                                    }}
                                >
                                    {barcode.label}
                                </Box>
                            ))}
                        </Stack>
                    </Box>

                    <FormControl fullWidth size="small">
                        <InputLabel>Supplier Format</InputLabel>

                        <Select
                            value={selectedSupplierFormat}
                            label="Supplier Format"
                            onChange={(e) =>
                                setSelectedSupplierFormat(e.target.value)
                            }
                        >
                            {selectedBarcodeFormats.map((barcode) => (
                                <MenuItem
                                    key={barcode.key}
                                    value={barcode.innerType}
                                >
                                    {barcode.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: { xs: 2, sm: 3 },
                        py: 2,
                        borderTop: "1px solid #e0e0e0",
                    }}
                >
                    <Button
                        onClick={() => {
                            setSupplierFormatModalOpen(false);
                            setSelectedSupplierFormat("");
                        }}
                        disabled={isSaving}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        startIcon={<SaveIcon />}
                        disabled={
                            !selectedSupplierFormat || isSaving
                        }
                        onClick={handleFinalSave}
                    >
                        {isSaving ? "Saving..." : "Save"}
                    </Button>
                </DialogActions>
            </Dialog>

            {/* BARCODE DETAIL DIALOG */}
            <Dialog
                open={barcodeModalOpen}
                onClose={() => setBarcodeModalOpen(false)}
                maxWidth={false}
                fullWidth
                PaperProps={{
                    sx: {
                        width: "calc(100% - 16px)",
                        maxWidth: "1125px",
                        maxHeight: "calc(100vh - 16px)",
                        borderRadius: "4px",
                        m: 1,
                        overflow: "hidden",
                        boxSizing: "border-box",
                    },
                }}
            >
                {/* DIALOG HEADER */}
                <DialogTitle
                    sx={{
                        px: { xs: 1.5, sm: 2, md: 3 },
                        py: 1.2,
                        borderBottom: "1px solid #ddd",
                        flexShrink: 0,
                    }}
                >
                    <Stack
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        gap={1}
                    >
                        <Stack
                            direction="row"
                            alignItems="center"
                            spacing={1}
                            sx={{
                                minWidth: 0,
                                overflow: "hidden",
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: {
                                        xs: 15,
                                        sm: 17,
                                        md: 20,
                                    },
                                    fontWeight: 600,
                                    color: "#333",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: {
                                        xs: "normal",
                                        sm: "nowrap",
                                    },
                                }}
                            >
                                Fill Dynamic Content -{" "}
                                {selectedBarcodeType?.label}
                            </Typography>

                            <IconButton
                                size="small"
                                onClick={() =>
                                    setBarcodePreviewOpen(true)
                                }
                                title="Preview Barcode"
                                sx={{
                                    ml: 0.5,
                                    color: "#4d9bd5",
                                    flexShrink: 0,

                                    "&:hover": {
                                        backgroundColor:
                                            "rgba(77, 155, 213, 0.1)",
                                        color: "#1976d2",
                                    },
                                }}
                            >
                                <VisibilityIcon
                                    sx={{ fontSize: 21 }}
                                />
                            </IconButton>
                        </Stack>

                        <IconButton
                            size="small"
                            onClick={() =>
                                setBarcodeModalOpen(false)
                            }
                            sx={{ flexShrink: 0 }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Stack>
                </DialogTitle>

                {/* DIALOG CONTENT */}
                <DialogContent
                    sx={{
                        px: { xs: 1.5, sm: 2, md: 3 },
                        py: 2,

                        /*
                         * IMPORTANT:
                         * Do not use overflow:hidden here.
                         * This allows Content 3, 4, 5, 6 to remain
                         * accessible on smaller screens.
                         */
                        overflowX: "hidden",
                        overflowY: "auto",

                        maxHeight: "calc(100vh - 130px)",
                        boxSizing: "border-box",
                    }}
                >
                    {selectedBarcode && (
                        <Box
                            sx={{
                                width: "100%",
                                minWidth: 0,
                            }}
                        >
                            {/* TOP SETTINGS */}
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: {
                                        xs: "1fr",
                                        sm: "1fr",
                                        md: "260px 1fr 240px",
                                    },
                                    gap: 1.2,
                                    alignItems: "center",
                                    my: 2,
                                }}
                            >
                                <TextField
                                    size="small"
                                    fullWidth
                                    placeholder="Set Qty Caption"
                                    value={
                                        selectedBarcode?.Barcode_SetQtyCaption ||
                                        ""
                                    }
                                    onChange={(e) =>
                                        handleInnerPropChange(
                                            "Barcode_SetQtyCaption",
                                            e.target.value
                                        )
                                    }
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            height: 35,
                                        },
                                    }}
                                />

                                <FormControl
                                    size="small"
                                    fullWidth
                                >
                                    <InputLabel>
                                        Format Type
                                    </InputLabel>

                                    <Select
                                        value={
                                            selectedBarcode?.BarcodeFormat ||
                                            ""
                                        }
                                        label="Format Type"
                                        onChange={(e) =>
                                            handleInnerPropChange(
                                                "BarcodeFormat",
                                                e.target.value
                                            )
                                        }
                                        sx={{
                                            height: 35,
                                        }}
                                    >
                                        <MenuItem value="Format 1 - Barcode Line">
                                            Format 1 - Barcode Line
                                        </MenuItem>

                                        <MenuItem value="Format 2 - QR Code">
                                            Format 2 - QR Code
                                        </MenuItem>
                                    </Select>
                                </FormControl>

                                <Stack
                                    direction="row"
                                    alignItems="center"
                                    spacing={0.5}
                                    sx={{
                                        minHeight: 35,
                                    }}
                                >
                                    <Checkbox
                                        checked={Boolean(
                                            selectedBarcode?.Barcode_With_Currency
                                        )}
                                        onChange={(e) =>
                                            handleInnerPropChange(
                                                "Barcode_With_Currency",
                                                e.target.checked
                                            )
                                        }
                                        size="small"
                                        sx={{
                                            p: 0.3,
                                        }}
                                    />

                                    <Typography
                                        sx={{
                                            fontSize: 14,
                                            whiteSpace: "nowrap",
                                        }}
                                    >
                                        With Currency
                                    </Typography>
                                </Stack>
                            </Box>

                            {/* CONTENT FIELDS */}
                            <Box
                                sx={{
                                    display: "grid",

                                    /*
                                     * Desktop:
                                     * 6 columns
                                     *
                                     * Tablet:
                                     * 3 columns
                                     *
                                     * Small tablet:
                                     * 2 columns
                                     *
                                     * Mobile:
                                     * 1 column
                                     */
                                    gridTemplateColumns: {
                                        xs: "1fr",
                                        sm: "repeat(2, minmax(0, 1fr))",
                                        md: "repeat(3, minmax(0, 1fr))",
                                        lg: "repeat(6, minmax(0, 1fr))",
                                    },

                                    gap: 1,
                                    width: "100%",
                                }}
                            >
                                {[1, 2, 3, 4, 5, 6].map(
                                    (index) => {
                                        const contentField =
                                            `Barcode_Content${index}`;

                                        const fontField =
                                            `Barcode_ContentFont${index}`;

                                        const currentValue =
                                            selectedBarcode?.[
                                            contentField
                                            ] || "";

                                        return (
                                            <Box
                                                key={index}
                                                sx={{
                                                    minWidth: 0,
                                                    width: "100%",
                                                }}
                                            >
                                                <FormControl
                                                    fullWidth
                                                    size="small"
                                                    sx={{
                                                        mb: 0.8,
                                                        minWidth: 0,
                                                    }}
                                                >
                                                    <InputLabel>
                                                        {`Content ${index}`}
                                                    </InputLabel>

                                                    <Select
                                                        value={
                                                            currentValue
                                                        }
                                                        label={`Content ${index}`}
                                                        onChange={(
                                                            e
                                                        ) =>
                                                            handleInnerPropChange(
                                                                contentField,
                                                                e.target
                                                                    .value
                                                            )
                                                        }
                                                        sx={{
                                                            height: 35,
                                                            fontSize: 13,
                                                            minWidth: 0,

                                                            "& .MuiSelect-select":
                                                            {
                                                                overflow:
                                                                    "hidden",
                                                                textOverflow:
                                                                    "ellipsis",
                                                                whiteSpace:
                                                                    "nowrap",
                                                            },
                                                        }}
                                                    >
                                                        <MenuItem value="">
                                                            <em>
                                                                None
                                                            </em>
                                                        </MenuItem>

                                                        {[
                                                            "Design",
                                                            "Color",
                                                            "Design Group",
                                                            "Product",
                                                            "Pattern",
                                                            "Size",
                                                            "Set Qty",
                                                            "Comp. ShortName",
                                                            "WS Rate 1",
                                                            "MRP Rate 1",
                                                            "Department",
                                                        ].map(
                                                            (
                                                                option
                                                            ) => (
                                                                <MenuItem
                                                                    key={
                                                                        option
                                                                    }
                                                                    value={
                                                                        option
                                                                    }
                                                                >
                                                                    {
                                                                        option
                                                                    }
                                                                </MenuItem>
                                                            )
                                                        )}
                                                    </Select>
                                                </FormControl>

                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    placeholder="FontSize"
                                                    value={
                                                        selectedBarcode?.[
                                                        fontField
                                                        ] || ""
                                                    }
                                                    onChange={(
                                                        e
                                                    ) =>
                                                        handleInnerPropChange(
                                                            fontField,
                                                            e.target
                                                                .value
                                                        )
                                                    }
                                                    sx={{
                                                        minWidth: 0,

                                                        "& .MuiOutlinedInput-root":
                                                        {
                                                            height: 35,
                                                        },

                                                        "& input": {
                                                            fontSize: 13,
                                                        },
                                                    }}
                                                />
                                            </Box>
                                        );
                                    }
                                )}
                            </Box>
                        </Box>
                    )}
                </DialogContent>

                {/* DIALOG ACTIONS */}
                <DialogActions
                    sx={{
                        px: { xs: 1.5, sm: 3 },
                        py: 0.8,
                        justifyContent: "flex-end",
                        borderTop: "1px solid #ddd",
                        flexShrink: 0,
                    }}
                >
                    <Button
                        variant="contained"
                        onClick={() =>
                            setBarcodeModalOpen(false)
                        }
                        sx={{
                            minWidth: 64,
                            height: 28,
                            textTransform: "none",
                            fontSize: 13,
                            py: 0,
                        }}
                    >
                        OK
                    </Button>
                </DialogActions>

                {/* BARCODE PREVIEW */}
                <Dialog
                    open={barcodePreviewOpen}
                    onClose={() =>
                        setBarcodePreviewOpen(false)
                    }
                    maxWidth={false}
                    PaperProps={{
                        sx: {
                            width: "fit-content",
                            maxWidth: "calc(100vw - 32px)",
                            maxHeight: "calc(100vh - 32px)",
                            m: 2,
                            borderRadius: 2,
                            overflow: "hidden",
                            boxShadow:
                                "0 20px 60px rgba(0,0,0,0.3)",
                        },
                    }}
                >
                    {/* HEADER */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 1.5,
                            py: 1,
                            borderBottom: "1px solid #e0e0e0",
                            backgroundColor: "#fff",
                            gap: 1,
                        }}
                    >
                        <Typography
                            sx={{
                                fontSize: 15,
                                fontWeight: 600,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                            }}
                        >
                            {selectedBarcodeType?.label} Preview
                        </Typography>

                        <IconButton
                            size="small"
                            onClick={() =>
                                setBarcodePreviewOpen(false)
                            }
                            sx={{ flexShrink: 0 }}
                        >
                            <CloseIcon fontSize="small" />
                        </IconButton>
                    </Box>

                    {/* IMAGE */}
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "#f5f5f5",
                            p: 1,
                            overflow: "auto",
                            maxWidth: "100vw",
                            maxHeight: "calc(100vh - 80px)",
                        }}
                    >
                        {selectedBarcodeType?.Img && (
                            <Box
                                component="img"
                                src={selectedBarcodeType.Img}
                                alt={`${selectedBarcodeType.label} barcode preview`}
                                sx={{
                                    display: "block",
                                    width: "auto",
                                    height: "auto",
                                    maxWidth:
                                        "calc(100vw - 64px)",
                                    maxHeight:
                                        "calc(100vh - 100px)",
                                    objectFit: "contain",
                                }}
                            />
                        )}
                    </Box>
                </Dialog>
            </Dialog>
        </Box>
    );
}

export default BarcodeSettings;